export const spotservellienceConstants ={
    
    GET_SPOTTYPE_REQUEST:'GET_SPOTTYPE_REQUEST',
    GET_SPOTTYPE_SUCCESS:'GET_SPOTTYPE_SUCCESS',
    GET_SPOTTYPE_FAILURE:'GET_SPOTTYPE_FAILURE',

    SAVE_QRINFO_REQUEST:'SAVE_QRINFO_REQUEST',
    SAVE_QRINFO_SUCCESS:'SAVE_QRINFO_SUCCESS',
    SAVE_QRINFO_FAILURE:'SAVE_QRINFO_FAILURE',

    UPDATE_QRINFO_REQUEST:'UPDATE_QRINFO_REQUEST',
    UPDATE_QRINFO_SUCCESS:'UPDATE_QRINFO_SUCCESS',
    UPDATE_QRINFO_FAILURE:'UPDATE_QRINFO_FAILURE',

    GET_QRINFO_REQUEST:'GET_QRINFO_REQUEST',
    GET_QRINFO_SUCCESS:'GET_QRINFO_SUCCESS',
    GET_QRINFO_FAILURE:'GET_QRINFO_FAILURE',

    GET_PATROLLING_REQUEST:'GET_PATROLLING_REQUEST',
    GET_PATROLLING_SUCCESS:'GET_PATROLLING_SUCCESS',
    GET_PATROLLING_FAILURE:'GET_PATROLLING_FAILURE',

}